import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//产品树
export async function productTree(params) {
    return post(erpserver+'/product/productTree', params, true)
}
//产品分类新增
export async function addOrupdateProductCategory(params) {
    return post(erpserver+'/masterData/addOrUpdateProductCategory', params, true)
}
//部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true)
}
//公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
//产品分类属性
export async function findClassificationAttributes(params) {
    return post(erpserver+'/masterData/findClassificationAttributes', params, true)
}
//产品新增
export async function addOrupdateProduct(params) {
    return post(erpserver+'/masterData/addOrUpdateProduct', params, true)
}
//规格新增
export async function addOrupdateProductSpecification(params) {
    return post(erpserver+'/masterData/addOrUpdateProductSpecification', params, true)
}
//规格列表
export async function getProductSpecification(params) {
    return post(erpserver+'/masterData/getProductSpecifications', params, true)
}
///单位接口
export async function getDictList(param) {
    return post(oaserver+'/oacurrency/getDictList',param,true)
}
//产品flag类型列表
export async function listFlags(param) {
    return post(erpserver+'/masterData/listFlags',param,true)
}
//产品-列表
export async function getPztypeContents(param) {
    return post(erpserver+'/masterData/getPztypeContents',param,true)
}

//转移产品规格
export async function productSpecifySwitch(param) {
    return post(erpserver+'/masterData/productSpecifySwitch',param,true)
}
// 板块

export async function getSectorList(param) {
    return post(oaserver+'/dict/sector/getSectorList',param,true)
}
//规格下发列表
export async function getSpecificationDistributeList(params) {
    return post(erpserver+'/masterData/getSpecificationDistributeList', params, true)
}